import { Routes } from "@angular/router";

export const content: Routes = [
  {
    path: "icons",
    loadChildren: () => import("../../components/icons/icons.module").then((m) => m.IconsModule),
    data: {
      breadcrumb: "Icons",
    },
  },
  {
    path: "admin",
    loadChildren: () => import("../../components/admin/admin.module").then((m) => m.AdminModule),
    data: {
      // title: "Admin",
      breadcrumb: "Admin",
    },

  },
  {
    path: "module",
    loadChildren: () => import("../../components/module/module.module").then((m) => m.ModuleModule),
    data: {
      // title: "Module",
      breadcrumb: "Module",
    },

  },
  {
    path: "institute",
    loadChildren: () => import("../../components/institute/institute.module").then((m) => m.InstituteModule),
    data: {
      // title: "Institue",
      breadcrumb: "Institute",
    },
  },
  {
    path: "spoc",
    loadChildren: () => import("../../components/spoc/spoc.module").then((m) => m.SpocModule),
    data: {
      // title: "SPOC",
      breadcrumb: "SPOC",
    }
  },
  {
    path: "mentor",
    loadChildren: () => import("../../components/mentor/mentor.module").then((m) => m.MentorModule),
    data: {
      // title: "Mentor",
      breadcrumb: "Mentor",
    },
  },
];
